export default "__VITE_ASSET__L4q7Rc8t__"